<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import loadScriptOnce from 'load-script-once'
export default {
  name: 'App',
  metaInfo: {
    htmlAttrs: {
      lang: 'ko'
    },
    meta: [
      { charset: 'utf-8' },
      // SEO setting
      { name: 'description', content: 'Gentle Map을 이용해 주소가 담긴 Excel 데이터를 손쉽게 지도로 만드세요.' },
      { name: 'keywords', content: '지도, 지도제작, excel, 프로젝트, 맵, 프로젝트맵, 플랫폼, 주소, 제작, 봉사활동, 봉사' },
      { name: 'rebots', content: 'index, follow' },
      { name: 'author', content: 'http://devstory.co.kr' },
      // mobile
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }
    ]
  },
  beforeCreate() {
    this.$store.commit('setIsDev', process.env.NODE_ENV)
    this.$store.commit('setIsMobile', window.innerWidth)
    this.$store.commit('setIsTablet', window.innerWidth)

    // Add window resize event listener
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    // Load SDK
    this.loadKakaoSDK()

    // Check is kakao browser
    this.checkIsKakaoBrowser()
  },
  destroyed() {
    // Remove window resize event listener
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    checkIsKakaoBrowser() {
      if (navigator.userAgent.toLowerCase().indexOf('kakaotalk') > -1) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '카카오 브라우저시군요 🙊',
          acceptText: '네 이동할게요.',
          cancelText: '괜찮아요. 계속할게요.',
          text: 'Chrome이나 Safari 브라우저에서 실행하는 것을 추천드려요!',
          accept: _ => {
            setTimeout(() => {
              // Chrome 브라우저가 존재하지 않을 경우 URL 복사
              this.copyUrl()
            }, 500)
            // Chrome 브라우저가 존재할 경우 이동
            window.location = window.location.href.replace(location.protocol, 'googlechrome:')
          }
        })
      }
    },
    copyUrl() {
      let el = document.createElement('textarea')
      el.value = window.location.href
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$vs.notify({
        title: '프로젝트 URL 복사 완료!',
        text: '다른 브라우저에 붙여넣으세요 🐈',
        color: 'success',
        icon: 'error',
        time: 3000,
        position: 'top-center'
      })
    },
    // Window resize listener
    handleResize() {
      // Check is mobile (true if width is less than 768px)
      this.$store.commit('setIsMobile', window.innerWidth)
    },
    loadKakaoSDK() {
      loadScriptOnce('https://developers.kakao.com/sdk/js/kakao.min.js')
        .then(_ => {
          Kakao.init(this.$config.kakao.appKey)
        })
        .catch(err => {
          this.$log.w(err)
        })
    }
  }
}

</script>
<style lang="scss">
:root {
  /* Style */
  --primary-color: #80A0F1;
  --primary-color-90: rgba(128, 210, 209, 0.9);
  --success-color: #80D2D1;
  --warning-color: #EBB248;
  --danger-color: #F56C6C;
  --info-color: #909399;

  /* Colors */
  --accent-color: rgba(0, 0, 0, 0.5);
  --font-color: #5b5777;
  --gray-color: #e4e7ed;
}

html,
body {
  /*height: 100%;*/
  font-family: 'NanumSquare', sans-serif;
  font-size: 15px;
  color: var(--font-color);
  -ms-content-zooming: none;
  -ms-touch-action: pan-x pan-y;
}

.height-100 {
  height: 100%;
}

#app {
  height: 100%;
}

.gm-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.gm-layout-vertical {
  display: flex;
  flex-direction: column;
}

.gm-layout-horizontal {
  display: flex;
  flex-direction: row;
}

.gm-layout-match-parent {
  width: 100%;
  height: 100%;
}

.gm-align-vertical-center {
  display: flex;
  align-items: center;
}

.gm-align-vertical-bottom {
  display: flex;
  align-items: baseline;
}

.gm-align-vertical-top {
  display: flex;
  align-items: flex-start;
}

.gm-width-match-parent {
  flex: 1;
}

.gm-line-break {
  white-space: pre-line;
}

/* Custom vuesax  */
.vs-dialog footer {
  padding-top: 6px;
  padding-bottom: 4px;

  .vs-button {
    margin-left: 10px !important;
  }
}

/* Mobile */
@media only screen and (max-width : 768px) {

  html,
  body {
    font-size: 12px;
  }

  /* Element UI */
  .el-notification {
    max-width: 250px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue